export default class ClearExternalCustomerSearchResults {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.externalCustomerSearchResults.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/clear_external_customer_search_results.js